import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import {Event} from '../../../libs/proto/commUnity_pb'


@Injectable({
  providedIn: 'root'
})
export class CompetitionConversionService {
  ToStorage(req: Event) {
    const w = new BinaryWriter();
    Event.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (event: Event, errorConvert: any) => void) {
    try {
      callback( Event.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(event: Event[]) {
    const rets = new Array<Uint8Array | number[]>();

    event.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (Event: Event[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<Event>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = Event.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }



}
